<div class="p-6">
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
    <div class="flex items-center gap-3">
      <button class="p-2 rounded-md hover:bg-gray-100 transition" title="Back" (click)="back()">
        <i class="fa-solid fa-arrow-left text-gray-600"></i>
      </button>
      <h1 class="text-lg font-semibold text-gray-800">{{ 'purchase.title' | translate }}</h1>
      
    
    </div>

    <div class="flex items-center bg-gray-100 rounded-md px-3 py-2 w-full sm:w-[600px]">
      <input
        type="text"
        [placeholder]="'purchase.searchPlaceholder' | translate"
        [formControl]="searchControl"
        class="bg-transparent outline-none text-sm text-gray-700 flex-1"
      />
      <i class="fa-solid fa-search text-gray-500"></i>
    </div>

    <button
      (click)="exportToPDF()"
      [disabled]="isExporting || results.length === 0 || results[0]?.status !== '02'"
      class="px-4 py-2 bg-[var(--primary)] text-white rounded-md hover:bg-[var(--primary-hover)] transition w-full sm:w-auto flex items-center justify-center gap-2 disabled:opacity-50"
    >
      <i *ngIf="isExporting" class="fa-solid fa-spinner fa-spin"></i>
      {{ isExporting ? ('purchase.exporting' | translate) : ('purchase.export' | translate) }}
    </button>
  </div>

  <div *ngIf="results.length > 0" class="mt-8 flex flex-col gap-8 items-center">
    <div class="flex flex-col items-center w-full">
      <ng-container *ngIf="results[0]?.status === '02'">
        <div *ngFor="let ticket of results[0]?.payment?.ticket" class="preview-wrapper bg-white shadow-lg border border-gray-100 overflow-hidden transform hover:scale-[1.01] transition-all duration-300 max-w-[550px] w-full">
          <div #previewContainer class="preview-container relative min-h-[150px] sm:min-h-[200px]">
            <div *ngIf="loadingLottery" class="skeleton-loader absolute inset-0 w-full h-full z-10 transition-opacity duration-300"></div>
            <img [src]="lotteryImage || '../../../../../../assets/images/testing.png'" alt="Ticket Background" class="w-full h-auto object-contain block" />
            <div class="ticket-number">
              <span class="alphabet">{{ ticket.alphabet }}</span>
              <span class="number">{{ ticket.number }}</span>
            </div>
          </div>
        </div>
      </ng-container>

      <div *ngIf="results[0]?.status !== '02'" class="w-full max-w-[1000px] mt-4">
        <div class="split-layout">
          <div class="screenshot-pane">
            <div class="screenshot-container">
              <img [src]="results[0]?.payment?.screenshot" alt="Payment Screenshot" class="screenshot-img" />
            </div>
          </div>

          <div class="details-pane">
            <div class="order-header-pane">
              <span class="status-badge" [ngClass]="{
                'status-pending': results[0]?.status === '01' || results[0]?.status === '04',
                'status-failed': results[0]?.status === '03'
              }">
                {{ 
                  results[0]?.status === '01' ? ('purchase.statusPending' | translate) : 
                  results[0]?.status === '03' ? ('purchase.statusFailed' | translate) : 
                  results[0]?.status === '04' ? ('purchase.statusPending' | translate) : 'Status: ' + results[0]?.status 
                }}
              </span>
            </div>

            <div class="info-section">
              <div class="info-grid-simple">
                <div class="info-row">
                  <span class="row-label">{{ 'purchase.labelName' | translate }}</span>
                  <span class="row-value">{{ results[0]?.payment?.name }}</span>
                </div>
                <div class="info-row">
                  <span class="row-label">{{ 'purchase.labelPhone' | translate }}</span>
                  <span class="row-value">{{ results[0]?.payment?.phone }}</span>
                </div>
                <div class="info-row">
                  <span class="row-label">{{ 'purchase.labelAddress' | translate }}</span>
                  <span class="row-value">{{ results[0]?.payment?.address }}</span>
                </div>
                <div class="info-row">
                  <span class="row-label">{{ 'purchase.labelDate' | translate }}</span>
                  <span class="row-value">{{ results[0]?.payment?.purchasedate | date:'short' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="states-wrapper" *ngIf="loading || (!loading && results.length === 0 && searchControl.value)">
    <div *ngIf="loading" class="state-container">
      <div class="loader-icon">
        <i class="fa-solid fa-circle-notch fa-spin"></i>
      </div>
      <p class="state-text">{{ 'purchase.searching' | translate }}</p>
    </div>

    <div *ngIf="!loading && results.length === 0 && searchControl.value" class="state-container">
      <div class="empty-icon">
        <i class="fa-solid fa-magnifying-glass"></i>
      </div>
      <p class="state-text">{{ 'purchase.noResults' | translate }}</p>
      <p class="state-subtext">{{ 'purchase.tryAgain' | translate }}</p>
    </div>
  </div>
</div>
